import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import BrandInfo from "@/src/config/SiteConfig";
import BrandContentInfo from "@/src/config/ContentConfig";
import { ISiteConfig, IContentConfig } from "@/src/@types/Settings";

interface NextPageCode<T extends Record<string, any> = any> {
    getStaticProps?: GetStaticProps<T>;
    getStaticPaths?: GetStaticPaths;
    default: NextPage<T>;
}

const BRAND_DATA = BrandInfo;
const BRAND_CONTENT_DATA = BrandContentInfo;

export class BrandService {
    static getCurrentBrandData(): ISiteConfig {
        return BRAND_DATA;
    }
    static getCurrentBrandContent(): IContentConfig {
        return BRAND_CONTENT_DATA;
    }
}
